import type { IconSvgObject } from './types';

const PlusIcon: IconSvgObject = [
  ["path", { d: "M11.9922 4.00012V20.0001M19.9922 12.0001H3.99222", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default PlusIcon;
